import { MultiSelectField } from "@rawa/ui/MultiSelectField"
import { fieldInstructions, fieldName } from "../fields"
import type { ControlRenderer } from "./types"

// The value is the chosen options' values, in the order they were chosen, or
// none once every one is removed.
export const dropdownMulti: ControlRenderer<"dropdownMulti"> = {
  Render: ({ field, value, onChange, error }) => (
    <MultiSelectField
      label={fieldName(field)}
      hint={fieldInstructions(field)}
      options={field.options.map((option) => ({
        id: option.value,
        name: option.label,
      }))}
      selectedIds={value ?? []}
      onChange={(ids) => onChange(ids.length === 0 ? undefined : ids)}
      placeholder={field.placeholder || "Choose options"}
      required={field.required}
      error={error}
    />
  ),
}
